import { IMessageTransformer } from '../../embedding/child.service';

interface EncodableMessage {
    command: string;
    payload: unknown;
}

function isEncodableMessage(message: any): message is EncodableMessage {
    return typeof message === 'object' && message && 'command' in message && 'payload' in message;
}

export class BtoaEncoder implements IMessageTransformer {
    async decode(message: any) {
        return message;
    }

    async encode(message: any) {
        if (!isEncodableMessage(message)) {
            return message;
        }

        if (message.command === 'VIEW_IMAGES') {
            message.payload = btoa(JSON.stringify(message.payload));
        }

        return message;
    }
}
